import NavigableValidator from "./navigableValidator";
import ObjectModel from "../objectModel";
import {INavigableValidatableModel} from "~/interfaces/navigableValidationInterfaces";
import {ErrorType} from "~/enums/ErrorType";
import {ValidationErrorMessage} from "~/enums/validationErrorMessage";
import ObjectModelTrigger from "~/models/objectModelTriggers/objectModelTrigger";
import ValidationError, {IValidationError, ValidationErrorLevel} from "~/models/validationError";
import {ObjectHelper} from "~/helpers/objectHelper";
import {ObjectModelTriggerBasedOnType} from "~/enums/objectModelTriggerBasedOnType";
import {DurationType} from "~/enums/durationType";

type TriggerContainer = (ObjectModel & INavigableValidatableModel<ObjectModel>) | (ObjectModelTrigger & INavigableValidatableModel<ObjectModelTrigger>);

export default class ObjectModelTriggersValidator extends NavigableValidator<TriggerContainer> {
  _validatorKey = "object_model_triggers";
  defaultMessage = ValidationErrorMessage.InvalidClearTrigger;
  defaultType = ErrorType.invalidClearTrigger;

  protected _validate(model: TriggerContainer): void {
    const children = ObjectHelper.toArray(model.object_model_triggers);

    for (const prop of children) {
      ObjectHelper.toArray(prop.property_updates).forEach(propertyUpdate => {
        if (propertyUpdate.clear_value) {
          const property = model.objectModel.findObjectModelProperty(propertyUpdate.property_client_id);

          if (property.is_required) {
            this.errors.push(this.buildValidationError(prop, ValidationErrorMessage.InvalidClearTrigger, ErrorType.invalidClearTrigger, {field: `clearWhenRequired-${prop.client_id}`}));
          }
        }
      })

      // prop based trigger with no configured prop
      if (prop.trigger_based_on_type === ObjectModelTriggerBasedOnType.TimeBasedEvent &&
        prop.first_trigger.type === DurationType.propertyBasedTimeSpan &&
        !prop.first_trigger.property_client_id && !prop.first_trigger.builtin_property_type) {
        this.errors.push(this.buildValidationError(prop, ValidationErrorMessage.MustBePresent, ErrorType.mustBeConfigured, {displayName: 'Choose Date/Time or Property'}));
      }

      this.validateConditionalRuleSets(prop);
    }
  }

  buildValidationError(model: ObjectModelTrigger, message, type, opts: Partial<IValidationError> = {}) {
    return new ValidationError({
      message: message,
      displayName: model.label_title,
      errorNavOpts: model.validation.errorNavOpts(this, this.validatorKey, model),
      type: type,
      section: this.section,
      level: ValidationErrorLevel.Error,
      field: this.validatorKey,
      ...opts
    });
  }

  private validateConditionalRuleSets(trigger: ObjectModelTrigger) {
    const activeConditionalRuleSets = trigger.activeConditionalRuleSets();
    if (activeConditionalRuleSets === null) return;

    if (Object.values(activeConditionalRuleSets).some(set => !set.isValid)) {
      this.errors.push(this.buildValidationError(trigger, ValidationErrorMessage.IncompleteCondtional, ErrorType.invalidValue, { field: `triggerConditional-${ trigger.client_id }` }));
    }
  }
}